<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="modal-header">
  <div class="modal-title f-20">Linked Assessments </div>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-7">
        <div class="form-group">
          <div class="left inline control-label mb-1">Key Word Search</div>
          <mat-chip-grid #keywordsList>
            <mat-chip-row *ngFor="let sQuery of filters.searchQuery" [selectable]="selectable" [removable]="removable"
              (removed)="remove(sQuery)">
              {{sQuery}}
              <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
            </mat-chip-row>
            <input class="form-control form-control-sm mat-autodd-input" #keywordInput [formControl]="keyCtrl"
              [matAutocomplete]="autoKeyword" [matChipInputFor]="keywordsList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="add($event)">
          </mat-chip-grid>
          <mat-autocomplete #autoKeyword="matAutocomplete" (optionSelected)="selected($event)">
            <mat-option *ngFor="let fK of filteredKeywords" [value]="fK">
              {{fK}}
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
      <div class="col-md-2 pt-4">
        <button class="btn bg-g-lightGreen btn-sm pull-right ml-2" (click)="fetchImpactAssessment()">Submit</button>
        <button class="btn bg-g-lightGreen btn-sm pull-right" (click)="initFilter()">Reset</button>
      </div>
      <div class="col-md-12 text-left">
        <div class="text-blue" *ngIf="(impactAssessment && (impactAssessment.length>0))">
          <div>{{endIndex}} out of {{totalCount}}</div>
        </div>
      </div>
      <div class="table-responsive box-shadow table-cont body-style">
        <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
        <table class="table table-fixed table-hover mb-0">
          <thead>
            <tr>
              <th class="text-center width-1pr"></th>
              <th class="width-12pr text-center" (click)="sortImpactAssessment('updatedDB_Id')">Id
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'updatedDB_Id' && !filters.IsDesc),
          'fa-sort-amount-desc': (filters.SortKey === 'updatedDB_Id' && filters.IsDesc) }" aria-hidden="true">
                </i>
              </th>
              <th class="width-12pr text-center" (click)="sortImpactAssessment('Regulator')">Regulator
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'Regulator' && !filters.IsDesc),
          'fa-sort-amount-desc': (filters.SortKey === 'Regulator' && filters.IsDesc) }" aria-hidden="true">
                </i>
              </th>
              <th class="width-37pr" (click)="sortImpactAssessment('Title')">Title
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'Title' && !filters.IsDesc),
          'fa-sort-amount-desc': (filters.SortKey === 'Title' && filters.IsDesc) }" aria-hidden="true">
                </i>
              </th>
              <th class="width-12pr text-center" (click)="sortImpactAssessment('ApplicationDate')">Effective Date
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'ApplicationDate' && !filters.IsDesc),
          'fa-sort-amount-desc': (filters.SortKey === 'ApplicationDate' && filters.IsDesc) }" aria-hidden="true">
                </i>
              </th>
              <th class="width-12pr text-center" (click)="sortImpactAssessment('Jurisdiction')">Division
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'Jurisdiction' && !filters.IsDesc),
          'fa-sort-amount-desc': (filters.SortKey === 'Jurisdiction' && filters.IsDesc) }" aria-hidden="true">
                </i>
              </th>
              <th class="width-12pr text-center" (click)="sortImpactAssessment('ImpactRating')">Impact Rating
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'ImpactRating' && !filters.IsDesc),
          'fa-sort-amount-desc': (filters.SortKey === 'ImpactRating' && filters.IsDesc) }" aria-hidden="true">
                </i>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="impactAssessment.length === 0">
            <tr>
              <td>No Data</td>
            </tr>
          </tbody>
          <tbody *ngIf="(impactAssessment && (impactAssessment.length > 0))" [style.max-height.px]="myInnerHeight">
            <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="35"
              (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight"
              *ngIf="impactAssessment.length > 0">
              <div *cdkVirtualFor="let item of impactAssessment; let i = index">
                <tr>
                  <td class="width-1pr text-center">
                    <input type="checkbox" [attr.checked]="checkedIfExist(item.id) ? checkedIfExist(item.id) : null"
                    [attr.disabled]="item.id === this.linkedAssessment.impactAssessmentId ? 'disabled' : null" (change)="selectItem($event, item.id)" />
                  </td>
                  <td class="width-12pr text-center tabel-td-scroll">
                    <span *ngIf="item.isMerged">
                      <div *ngFor="let option of item.merged_Id|stringToArrayParent;">{{option}}</div>
                    </span>
                    <span *ngIf="!item.isMerged">
                      {{item.updatedDbId}}
                    </span>
                  </td>
                  <td class="width-12pr text-center tabel-td-scroll">{{item.regulator}}</td>
                  <td class="width-37pr tabel-td-scroll">{{item.title}}</td>
                  <td class="width-12pr text-center tabel-td-scroll">{{item.applicationDate |
                    date:'dd-MMM-yyyy'}}</td>
                  <td class="width-12pr text-center tabel-td-scroll">{{item.jurisdiction}}</td>
                  <td class="width-12pr text-center tabel-td-scroll">{{item.impactRating}}</td>
                </tr>
              </div>
            </cdk-virtual-scroll-viewport>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn bg-g-lightGreen btn-sm" (click)="closeDialog()">Save</button>
</div>
